import { DocumentGroup } from '../../../../../../interfaces/DocumentGroup';

export default function getGroupedContractsPeriod(documentGroups: DocumentGroup[], systemCode: string): Date {
  const documentDates: Date[] = [];
  documentGroups?.flatMap((documentGroup) =>
    documentGroup.documents.map((document) => systemCode === document.contract.systemCode && documentDates.push(document.date)));
  return documentDates.length > 0 ? documentDates.reduce((date1, date2, index) => (date2 > date1) && index ? date2 : date1) : null;
}
